import { create } from 'zustand/react'

import { ProjectStore } from '../../entities/projects/stores/project.store'
import { LoadState } from '../constants/common.constants'

interface CommonStore {
  status: LoadState
  init?: () => void
  initAuthenticated: (projectStore: ProjectStore) => void
}

export const useCommonStore = create<CommonStore>((set) => ({
  status: LoadState.Loading,
  initAuthenticated: async (projectStore: ProjectStore) => {
    await Promise.all([projectStore.loadProjects])

    return set({ status: LoadState.Loaded })
  },
}))
